import React, { useRef } from "react";
import { Formik } from "formik";
import Form from "./components/Form";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import { getStatesDetail } from "./components/StatesHelper";
import { useEffect } from "react";
import Spin from "../../common/Spin";
import { API, fileUpload } from "../../../config";
import { toast } from "react-toastify";
import { AddStatesSchema } from "../../common/Validation";

const EditStates = ({ statesId, toggleStatesModal, showStates }) => {
  const [loading, setLoading] = useState(false);
  const [statesData, setStatesData] = useState();
  const formValues = useRef();
  let existingValues = [];
  let overwrittenFields = [];

  const handleFormSubmit = async (value) => {
    const formData = new FormData();
    formData.append("name", value?.name ? value?.name : "");
    formData.append("short_name", value?.short_name ? value?.short_name : "");
    formData.append("_method", "put");

    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.GET_ADMIN_STATE_LIST}/${statesId}`,
        formData
      );
      setLoading(false);
      if (data) {
        toast.success(data?.message);
        toggleStatesModal();
      }
      return data?.data;
    } catch (error) {
      setStatesData(value);
      setLoading(false);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const data = await getStatesDetail(statesId);
        setStatesData(data);
        setLoading(false);
      } catch (e) {
        setStatesData(null);
      }
    }
    fetchData();
  }, [statesId]);

  return (
    <>
      <Modal
        show={showStates}
        onHide={toggleStatesModal}
        dialogClassName="small-review extra-small-popup"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          Edit State
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              name: statesData?.name ? statesData?.name : "",
              short_name: statesData?.short_name ? statesData?.short_name : ""
            }}
            enableReinitialize
            innerRef={formValues}
            onSubmit={handleFormSubmit}
            validateOnBlur={true}
            validateOnChange={true}
            validationSchema={AddStatesSchema}
          >
            {({
              values,
              setErrors,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              return (
                <>
                  {loading && <Spin />}
                  <Form
                    values={values}
                    errors={errors}
                    setErrors={setErrors}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    formValues={formValues}
                    overwrittenFields={overwrittenFields}
                    existingValues={existingValues}
                    toggleStatesModal={toggleStatesModal}
                  />
                </>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditStates;
